<template>
  <div>
    <b-modal
      ref="modal"
      title="Lançamento no caixa"
      header-class="border-bottom-0"
      size="xs"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            Abrir caixa
          </div>
        </div>
      </div>

      <error-handler :error="error" />

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="handleStore()"
        >
          <i class="fas fa-check"></i> Abrir caixa
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form.js";

export default {
  components: {

  },

  props: {
  },

  data : () => ({
    account : null,
    error : null,
  }),

  methods: {
    open(account) {
      this.account = account
      this.$refs.modal.show();
    },

    async handleStore() {
      await this.$store.dispatch('drawer/postStartShift', { account_id : this.account.id })

      await this.$store.dispatch('account/getAccounts')

      this.$refs.modal.hide();
    }
  },
};
</script>
